;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.payment.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var listState = {
      name: 'payment.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('paymentList')
        }]
      },
      views: {
        'main@': {
          controller: ['pagination', function (pagination) {
            this.pagination = pagination
          }],
          controllerAs: 'list',
          template: '<payment-list pagination="list.pagination"></payment-list>'
        }
      },
      ncyBreadcrumb: {
        label: 'Liste des paiements',
        parent: ''
      }
    }

    $stateProvider
      .state(listState)
  }
})(window.angular)
